import { PlotPoint } from '../../../interfaces/Charts';

const RECT_WIDTH = 5;
const RECT_BORDER_RADIUS = RECT_WIDTH / 2;

export const roundedRect = ({ x, y }: PlotPoint, yCenter = 0) => {
  const isNegative = y > yCenter;

  if (!isNegative) {
    return `M ${x - RECT_BORDER_RADIUS} ${yCenter} l ${RECT_WIDTH} 0 0 -${yCenter -
      y} m 0 0 a ${RECT_BORDER_RADIUS} ${RECT_BORDER_RADIUS} 0 0 0 -${RECT_WIDTH} 0 l 0 ${yCenter -
      y}`;
  } else {
    return `M ${x - RECT_BORDER_RADIUS} ${yCenter} l ${RECT_WIDTH} 0 0 ${-yCenter +
      y} m 0 0 a ${RECT_BORDER_RADIUS} ${RECT_BORDER_RADIUS} 0 0 1 ${-RECT_WIDTH} 0 l 0 ${yCenter -
      y}`;
  }
};
